/**
 * The canonical exchange stores its first argument as a YOU turn.
 * A camera or screen failure is a local system notice. It must not become a visitor line.
 */
export function visualObservationCanonicalUserText(
  status: 'success' | 'error',
  text: string,
): string | null {
  if (status === 'error') return null
  const trimmed = text.trim()
  return trimmed ? trimmed : null
}

/** App writes a successful note with these prefixes. The canonical store keeps it as a user turn. */
export const VISUAL_OBSERVATION_PREFIX = {
  webcam: 'I saw: ',
  screen: 'I saw on your screen: ',
} as const

export function visualObservationSuccessText(modality: 'webcam' | 'screen', detail: string): string {
  return VISUAL_OBSERVATION_PREFIX[modality] + detail
}

/**
 * A stored camera or screen note stays in the canonical transcript, so the recall
 * grounding, the brief and the summary still read it. It renders as a system notice.
 */
export function visualObservationModalityOfStoredNote(text: string): 'webcam' | 'screen' | null {
  const trimmed = text.trimStart()
  if (trimmed.startsWith(VISUAL_OBSERVATION_PREFIX.screen)) return 'screen'
  if (trimmed.startsWith(VISUAL_OBSERVATION_PREFIX.webcam)) return 'webcam'
  return null
}
